import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { temporaryBlockedRetryUrl } from '../pending-operation/shared/pending-operation-params'
import { ResolvePendingDataGuard } from '../pending-operation/shared/resolve-pending-data.guard'
import { CardLayoutComponent } from '../shared/card-layout/card-layout.component'
import { BlockedAccountGuard } from './shared/guard/blocked-account.guard'
import { ClosingAccountGuard } from './shared/guard/closing-account.guard'
import { ResolveTemporaryBlockedGuard } from './shared/guard/temporary-blocked.guard'
import { BlockedAccountPageComponent } from './status-page/blocked-account-page/blocked-account-page.component'
import { ClosingAccountPageComponent } from './status-page/closing-account-page/closing-account-page.component'
import { InactiveAccountPageComponent } from './status-page/inactive-account-page/inactive-account-page.component'
import { TemporaryBlockedAccountPageComponent } from './status-page/temporary-blocked-account-page/temporary-blocked-account-page.component'
import { UnconfirmedAccountPageComponent } from './status-page/unconfirmed-account-page/unconfirmed-account-page.component'
import { UnconfirmedAccountGuard } from './shared/guard/unconfirmed-account-guard'

const routes: Routes = [
  {
    path: 'account',
    component: CardLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/',
      },
      {
        path: 'temporary-blocked',
        component: TemporaryBlockedAccountPageComponent,
        resolve: {
          pendingData: ResolvePendingDataGuard,
          [temporaryBlockedRetryUrl]: ResolveTemporaryBlockedGuard,
        },
        data: { title: 'Blocco temporaneo' },
      },
      {
        path: 'blocked',
        component: BlockedAccountPageComponent,
        canActivate: [BlockedAccountGuard],
        data: { title: 'Account bloccato' },
      },
      {
        path: 'unconfirmed',
        component: UnconfirmedAccountPageComponent,
        canActivate: [UnconfirmedAccountGuard],
        resolve: {
          pendingData: ResolvePendingDataGuard,
        },
        data: { title: 'Account in attesa di conferma' },
      },
      {
        path: 'inactive',
        component: InactiveAccountPageComponent,
        data: { title: 'Account inattivo' },
      },
      {
        path: 'closing',
        component: ClosingAccountPageComponent,
        canActivate: [ClosingAccountGuard],
        data: { title: 'Account in chiusura' },
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
